/* eslint-disable */
import React, { useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

export const TransmissionTypeEditForm = (props) => {
    const lang = useTranslation();
    const blankDataItem = {
        ...props?.item,
        SID: props?.item?.SID ?? 0,
        Name: props?.item?.copy ? 'copy of ' + props?.item?.Name : props?.item?.Name ?? '',
        Archive: props?.item?.Archive ?? false,
        IsDefault: props?.item?.IsDefault ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);

    //function to check the validation in form
    const isValid = () => {
        if (!dataItem.Name || dataItem.Name == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async (e) => {

        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID ?? 0,
            Name: dataItem?.Name,
            Archive: dataItem?.Archive ?? false,
            IsDefault: dataItem?.IsDefault ?? false,
            checkDuplicate: true,
            query: [["Name", "=", dataItem.Name]]
        }
        console.log(saveData);

        let res = await API.saveData(ENTITYNAME.TransmissionTypes, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.TRANSMISSION_TYPES, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.TransmissionTypes);
            props.cancelEdit();
            props.refresh();
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else if (e.target.name == "IsDefault") {
            setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }

    }

    return (
        <BossDialog
            title={props.item.SID > 0 ? props.item.Name : lang.transmission_type_header}
            onClose={props.cancelEdit}
            width={"420px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2 form-group">
                <div className="col">
                    <label>{lang.name_label} *</label>
                    <input
                        name="Name"
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Name}
                    />
                </div>
            </div>
            <div className="row form-group mt-2">
                <div className="col-6" >
                    <input
                        type="checkbox"
                        name="Archive"
                        onChange={onChange}
                        value={dataItem.Archive}
                        checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                </div>
                <div className="col-6" >
                    <input
                        type="checkbox"
                        name="IsDefault"
                        onChange={onChange}
                        value={dataItem.IsDefault}
                        checked={dataItem.IsDefault} />
                    <label className="ml-1">{lang.is_default_label}</label>
                </div>
            </div>
        </BossDialog>)
};